import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Tracks scroll position relative to registered section refs.
 * Returns which sections have been scrolled past (top of section reached top 60% of viewport).
 */
export function usePageScrollTracker() {
  const sectionsRef = useRef({});
  const [passed, setPassed] = useState({});

  const register = useCallback((name, element) => {
    if (element) {
      sectionsRef.current[name] = element;
    }
  }, []);

  useEffect(() => {
    function onScroll() {
      const threshold = window.innerHeight * 0.6;
      const updates = {};
      let changed = false;

      Object.entries(sectionsRef.current).forEach(([name, el]) => {
        if (name.startsWith('_passed_')) return;
        const rect = el.getBoundingClientRect();
        const isPassed = rect.bottom < threshold;
        updates[name] = isPassed;
        if (isPassed !== sectionsRef.current[`_passed_${name}`]) {
          sectionsRef.current[`_passed_${name}`] = isPassed;
          changed = true;
        }
      });

      if (changed) {
        setPassed({ ...updates });
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return { register, passed };
}
